import { find, first } from 'lodash';
function findPrimaryOrFirst() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return find(items, {
    is_primary: true
  }) || first(items) || {};
}
export default findPrimaryOrFirst;